import { React, StyledProps, withStyles } from '@api';
import { Card, CardMedia, Typography }  from '@material-ui/core'
import { PrimaryButton }                from 'centric-ui-components'
import { landingScreen }                  from '@resources'

const styles = theme => ({
  imageCard: {
    height: 177,
    width: 281,
    boxShadow: 'none'
  },
  imageCardMedia: {
    width: '100%',
    height: '100%'
  },
  helperText: {
    textAlign: 'center',
    width: '332px',
    height: '100px',
    paddingBottom: 30
  },
  emptyContainer: {
    height: '100%',
    display: 'flex',
    alignContent: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

interface MyProps extends StyledProps {
}

@(withStyles as any)(styles)
export class LandingScreenComponent extends React.Component<MyProps> {
  render() {
    const {
            classes
          } = this.props
    return (
      <div className={classes.emptyContainer}>
        <Card className={classes.imageCard}>
          <CardMedia
            className={classes.imageCardMedia}
            image={landingScreen}
            title='Process Explanation'
          />
        </Card>
        <Typography classes={{root: classes.helperText}}>
          Start building products by drag and dropping inspiration images from your desktop, or dropping library items found in the sidebar.
          <br/>
          <br/>
          or
        </Typography>
        <PrimaryButton>
          CREATE NEW PRODUCT
        </PrimaryButton>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/landingScreen/components/LandingScreen.tsx